export default {
  requiredLights: 2,
  tubeWidth: 400,
  boxLength: 305,
  boxHeight: 255,
  boxWidth: 125,
};
